import React from "react";

import estados from "../../services/estados";
import api from "../../services/api";
import { store } from "react-notifications-component";
import GenericUpper from "../../components/generic-upper";
import { FiliaisAddContainer } from "./styles";
import { Container } from "react-grid-system";
import Input from "../../components/input/input_v2";
import Button  from '../../components/button/button_v2';
import Select from "../../components/select/select_v2";
import buscaCep from "../../services/buscaCep";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";
import { string } from "prop-types";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
class AddFiliais extends React.Component {
    state = {
        nome_fantasia: "",
        erroFantasia: false,
        erroFantasiaMsg: false,
        razao_social: "",
        erroSocial: false,
        erroSocialMsg: false,
        cnpj: "",
        erroCnpj: false,
        erroCnpjMsg: false,
        telefone: "",
        erroTelefone: false,
        erroTelefoneMsg: false,
        cep: "",
        erroCep: false,
        erroCepMsg: false,
        endereco: "",
        erroEndereco: false,
        erroEnderecoMsg: false,
        cidade: "",
        erroCidade: false,
        erroCidadeMsg: false,
        bairro: "",
        erroBairro: false,
        erroBairroMsg: false,
        numero: "",
        erroNumero: false,
        erroNumeroMsg: false,
        estado: "",
        erroEstado: false,
        erroEstadoMsg: false,
        loading: false
    };

    // mapeia nome do campo -> [flagDeErro, mensagemDeErro]
fieldMap = {
    nome_fantasia: ["erroFantasia", "erroFantasiaMsg"],
    razao_social:  ["erroSocial",   "erroSocialMsg"],
    cnpj:          ["erroCnpj",     "erroCnpjMsg"],
    telefone:      ["erroTelefone", "erroTelefoneMsg"],
    telefone_emergencia: ["erroTelefone", "erroTelefoneMsg"],
    cep:           ["erroCep",      "erroCepMsg"],
    endereco:      ["erroEndereco", "erroEnderecoMsg"],
    bairro:        ["erroBairro",   "erroBairroMsg"],
    numero:        ["erroNumero",   "erroNumeroMsg"],
    cidade:        ["erroCidade",   "erroCidadeMsg"],
    estado:        ["erroEstado",   "erroEstadoMsg"],
  };
  
  // validação local
  validate = async () => {
    const { nome_fantasia, razao_social, cnpj, telefone, cep, endereco, bairro, numero, cidade, estado } = this.state;
    const required = { nome_fantasia, razao_social, cnpj, telefone, cep, endereco, bairro, numero, cidade, estado };

    let ok = true;
    const next = {};

    Object.entries(required).forEach(([field, value]) => {
      const v = (value ?? "").toString().trim();
      const map = this.fieldMap[field];
      if (!map) return;

      if (!v) {
        ok = false;
        next[map[0]] = true;
        next[map[1]] = "Campo obrigatório.";
      } else {
        next[map[0]] = false;
        next[map[1]] = "";
      }
    });

    if (cnpj && cnpj.toString().trim()) {
      const resultado = await validadorCpfCnpj(cnpj);
      if (!resultado.valido) {
        ok = false;
        next.erroCnpj = true;
        next.erroCnpjMsg = resultado.erro || "Informe um CNPJ válido.";
      }
    }

    this.setState(next);
    return ok;
  };

  handleBlurCnpj = async () => {
    const { cnpj } = this.state;
    if (!cnpj || !cnpj.toString().trim()) return;

    const resultado = await validadorCpfCnpj(cnpj);
    if (!resultado.valido) {
      this.setState({
        erroCnpj: true,
        erroCnpjMsg: resultado.erro || "Informe um CNPJ válido.",
      });
    } else {
      this.setState({ erroCnpj: false, erroCnpjMsg: "" });
    }
  };

  // submit do formulário
  handleSubmit = async (e) => {
    e.preventDefault();
    if (!(await this.validate())) {
      store.addNotification({
        title: "Atenção",
        message: "Preencha os campos obrigatórios.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }
    this.handlePost();
  };
  
    fetchCep = async () => {
        const { cep } = this.state;
        
        try {
            const responseCep = await buscaCep(cep);
            const { logradouro, localidade, bairro, uf } = responseCep;

            this.setState({
                endereco: logradouro,
                cidade: localidade,
                bairro: bairro,
                estado: uf
            });
        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    handlePost = async e => {
        this.setState({ loading: true });

        const {
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            cep,
            endereco,
            cidade,
            bairro,
            numero,
            estado
        } = this.state;

        const payload = {
            nome_fantasia,
            razao_social,
            telefone_emergencia: telefone,
            cnpj,
            telefone,
            cep,
            endereco,
            bairro,
            numero,
            cidade,
            estado,
            is_matriz: 0
        };

        try {
            const response = await api.post("/filiais/", payload);

            if (response.status === 201) {
                this.props.history.push("/filiais");
                this.setState({ loading: false });
                store.addNotification({
                    title: "Sucesso!",
                    message: "A filial foi cadastrada corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } catch (err) {
            this.setState({ loading: false });
          
            const arr = err?.response?.data?.message;
          
            if (Array.isArray(arr)) {
              const next = {};
          
              arr.forEach((msg) => {
                // Ex.: "razao_social should not be empty"
                const m = String(msg).match(/^([a-zA-Z_]+)\b/);
                if (!m) return;
          
                let field = m[1];
                if (field === "telefone_emergencia") field = "telefone"; // tratativa
          
                const map = this.fieldMap[field];
                if (map) {
                  next[map[0]] = true;
                  next[map[1]] = "Campo obrigatório.";
                }
              });
          
              // garante que campos não citados sejam limpos
              Object.entries(this.fieldMap).forEach(([field, [flag, msgKey]]) => {
                if (!(flag in next)) {
                  next[flag] = this.state[flag];   // mantém estado atual
                  next[msgKey] = next[msgKey] ?? this.state[msgKey];
                }
              });
          
              this.setState(next);
          
              store.addNotification({
                title: "Erro!",
                message: "Verifique os campos em vermelho.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
              });
          
              return;
            }
          
            // fallback genérico
            store.addNotification({
              title: "Erro!",
              message: err?.response?.data?.error || "Erro ao salvar.",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: { duration: 4000, onScreen: true }
            });
          }     
    };

    render() {

        const {
            nome_fantasia,
            erroFantasia,
            erroFantasiaMsg,
            razao_social,
            erroSocial,
            erroSocialMsg,
            cnpj,
            erroCnpj,
            erroCnpjMsg,
            telefone,
            erroTelefone,
            erroTelefoneMsg,
            cep,
            erroCep,
            erroCepMsg,
            endereco,
            erroEndereco,
            erroEnderecoMsg,
            cidade,
            erroCidade,
            erroCidadeMsg,
            bairro,
            erroBairro,
            erroBairroMsg,
            numero,
            erroNumero,
            erroNumeroMsg,
            estado,
            erroEstado,
            erroEstadoMsg,
            loading
        } = this.state;

        return (
            <>
                <GenericUpper
                    title="Filiais"
                    subtitle="Cadastre uma filial"
                ></GenericUpper>

                <FiliaisAddContainer>

                    <Container>
                        <form>
                            <Input
                                name="nome_fantasia"
                                type="text"
                                label="Nome Fantasia"
                                id="nome_fantasia_id"
                                value={nome_fantasia}
                                onChange={e => this.setState({ nome_fantasia: e, erroFantasia: false })}
                                erro={erroFantasia}
                                messageErro={erroFantasiaMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="razao_social"
                                type="text"
                                label="Razão Social"
                                id="razao_social_id"
                                value={razao_social}
                                onChange={e => this.setState({ razao_social: e, erroSocial: false })}
                                erro={erroSocial}
                                messageErro={erroSocialMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="cnpj"
                                type="text"
                                label="CNPJ"
                                id="cnpj_id"
                                value={cnpj}
                                onChange={e => this.setState({ cnpj: e, erroCnpj: false })}
                                onBlur={this.handleBlurCnpj}
                                erro={erroCnpj}
                                messageErro={erroCnpjMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="telefone"
                                type="text"
                                label="Telefone"
                                id="telefone_id"
                                value={telefone}
                                onChange={e => this.setState({ telefone: e, erroTelefone: false })}
                                erro={erroTelefone}
                                messageErro={erroTelefoneMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="cep"
                                type="text"
                                label="CEP"
                                id="cep_id"
                                value={cep}
                                onChange={e => this.setState({ cep: e, erroCep: false })}
                                onBlur={this.fetchCep}
                                erro={erroCep}
                                messageErro={erroCepMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="endereco"
                                type="text"
                                label="Endereço"
                                id="endereco_id"
                                value={endereco}
                                onChange={e => this.setState({ endereco: e, erroEndereco: false })}
                                erro={erroEndereco}
                                messageErro={erroEnderecoMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="numero"
                                label="Número"
                                id="numero_id"
                                value={numero}
                                onChange={e => this.setState({ numero: e, erroNumero: false })}
                                erro={erroNumero}
                                messageErro={erroNumeroMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="bairro"
                                type="text"
                                label="Bairro"
                                id="bairro_id"
                                value={bairro}
                                onChange={e => this.setState({ bairro: e, erroBairro: false })}
                                erro={erroBairro}
                                messageErro={erroBairroMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Input
                                name="cidade"
                                type="text"
                                label="Cidade"
                                id="cidade_id"
                                value={cidade}
                                onChange={e => this.setState({ cidade: e, erroCidade: false })}
                                erro={erroCidade}
                                messageErro={erroCidadeMsg}
                                marginBottom="32px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <Select
                                name="estado"
                                className="select"
                                label="Estado"
                                id="estado_id"
                                value={estado}
                                onChange={state => this.setState({ estado: state.value, erroEstado: false })}
                                options={estados}
                                estado={true}
                                erro={erroEstado}
                                messageErro={erroEstadoMsg}
                                marginBottom="48px"
                                height="auto"
                                labelWithAsterisk
                            />

                            <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <Button  
                                    width='100%'
                                    height='50px'
                                    value='CADASTRAR'
                                    outline={false}
                                    disabled={loading}
                                    onClick={(e) => { e.preventDefault(); this.handleSubmit(e); }}
                                    loading={loading}
                                />
                            </div>
                        </form>
                    </Container>
                </FiliaisAddContainer>
            </>
        );
    }
}

export default AddFiliais;
